export const ObjectValues = [
  'check',
  'Sno',
  'Action',
  'movieID',
  'posterURL',
  'title_En',
  'title_Te',
  'about_En',
  'about_Te',
  'ottReleasedDate',
  'movieReleasedDateUI',
  'allMoviesReleasedDate',
  'tags',
  'adminTagsGood',
  'adminTagsBad',
  'movieDirectedBy',
  'movieDirectedBy_Te',
  'movieProducedBy',
  'movieProducedBy_Te',
  'movieCast',
  'movieCast_Te',
  'movieCinematography',
  'movieCinematography_Te',
  'movieEditedBy',
  'movieEditedBy_Te',
  'movieMusicBy',
  'movieMusicBy_Te',
  'movieDialogueBy',
  'movieDialogueBy_Te',
  'movieWrittenBy',
  'movieWrittenBy_Te',
  'movieScreenplayBy',
  'movieScreenplayBy_Te',
  'movieStoryBy',
  'movieStoryBy_Te',
  'ottPlatform',
  'netflixLink',
  'primeLink',
  'sonyLiv',
  'sunNextLink',
  'youtubeLink',
  'zee5Link',
  'ahaLink',
  'hotstarLink',
  'jioCinemaLink',
  'etvApp',
  'wikipediaLink',
  'ageRestriction',
  'basedOn_En',
  'basedOn_Te',
  'boxOffice',
  'budget',
  'contentType',
  'distributedBy_En',
  'distributedBy_Te',
  'genre_En',
  'genre_Te',
  'language',
  'yousayRating',
  'movieRating',
  'narratedBy_En',
  'narratedBy_Te',
  'productionCompany_En',
  'productionCompany_Te',
  'runningTime',
]

export const ObjectValuesNOEpisodes = [
  'check',
  'Sno',
  'Action',
  'movieID',
  'posterURL',
  'title_En',
  'title_Te',
  'about_En',
  'about_Te',
  'ottReleasedDate',
  'movieReleasedDateUI',
  'allMoviesReleasedDate',
  'tags',
  'adminTagsGood',
  'adminTagsBad',
  'movieDirectedBy',
  'movieDirectedBy_Te',
  'movieProducedBy',
  'movieProducedBy_Te',
  'movieCast',
  'movieCast_Te',
  'movieCinematography',
  'movieCinematography_Te',
  'movieEditedBy',
  'movieEditedBy_Te',
  'movieMusicBy',
  'movieMusicBy_Te',
  'movieDialogueBy',
  'movieDialogueBy_Te',
  'movieWrittenBy',
  'movieWrittenBy_Te',
  'movieScreenplayBy',
  'movieScreenplayBy_Te',
  'movieStoryBy',
  'movieStoryBy_Te',
  'ottPlatform',
  'netflixLink',
  'primeLink',
  'sonyLiv',
  'sunNextLink',
  'youtubeLink',
  'zee5Link',
  'ahaLink',
  'hotstarLink',
  'etvApp',
  'wikipediaLink',
  'ageRestriction',
  'basedOn_En',
  'basedOn_Te',
  'boxOffice',
  'budget',
  'contentType',
  'distributedBy_En',
  'distributedBy_Te',
  'genre_En',
  'genre_Te',
  'noOfEpisodes',
  'language',
  'yousayRating',
  'movieRating',
  'narratedBy_En',
  'narratedBy_Te',
  'productionCompany_En',
  'productionCompany_Te',
  'runningTime',
]
